import React, { Fragment, PureComponent } from 'react';
import { VirtualBrand } from '~/Api/Analytics/VirtualBrand';
import { Pagination } from '~/Api/Pagination';
import { formatCondensedHumanDate } from '~/DateTime';
import { Record, Sentence } from '~/MedicinalBrandsAnalytics/VirtualBrand/History';
import HistoryIcon from '~/MedicinalBrandsAnalytics/VirtualBrand/HistoryIcon';
import HistorySentence from '~/MedicinalBrandsAnalytics/VirtualBrand/HistorySentence';
import ActivityIndicator from '~/UI/ActivityIndicator';
import SimplePaginator from '~/UI/SimplePaginator';

import styles from './styles.less';

interface Props {
	virtualBrand: VirtualBrand;
	currency: string | null;
	history: Record[] | null;
	pagination: Pagination | null;
	isFetching: boolean;
	onLoad(id: string, currency: string | null): void;
}

export default class HistoryTab extends PureComponent<Props> {
	componentDidMount() {
		const { virtualBrand, currency, onLoad } = this.props;
		onLoad(virtualBrand.id, currency);
	}

	componentDidUpdate(prevProps: Props) {
		const { virtualBrand, currency, onLoad } = this.props;

		if (prevProps.virtualBrand !== virtualBrand || prevProps.currency !== currency) {
			onLoad(virtualBrand.id, currency);
		}
	}

	renderContext(context: Sentence[]) {
		let previousDate: Date | null = null;

		return context.map((sentence, i) => {
			const { date } = sentence;
			const isAnotherDay =
				date &&
				(!previousDate ||
					previousDate.getFullYear() !== date.getFullYear() ||
					previousDate.getMonth() !== date.getMonth() ||
					previousDate.getDate() !== date.getDate());

			previousDate = date;

			return (
				<Fragment key={`${JSON.stringify(sentence)}-${i}`}>
					{isAnotherDay && date ? <h2 className={styles.h2}>{formatCondensedHumanDate(date)}</h2> : null}
					<p>
						<HistorySentence sentence={sentence} />
					</p>
				</Fragment>
			);
		});
	}

	render() {
		const { virtualBrand, currency, history, pagination, isFetching, onLoad } = this.props;

		return (
			<div>
				{history?.map((record) => (
					<Fragment key={record.hash}>
						<div className={styles.newsItemHeader}>
							<HistoryIcon record={record} />
							<h1 className={styles.h1}>
								<HistorySentence sentence={record.summary} />
							</h1>
						</div>
						<div className={styles.newsItemContent}>{this.renderContext(record.context)}</div>
					</Fragment>
				))}

				{isFetching ? (
					<ActivityIndicator />
				) : pagination && pagination.hasNextPage() ? (
					<SimplePaginator count={pagination.perPage} onLoadMore={() => onLoad(virtualBrand.id, currency)} />
				) : null}
			</div>
		);
	}
}
